<template>
    <div>
        <navigation></navigation>
        <newsList :settings="aboutSettings"></newsList>
        <footer1></footer1>
    </div>
</template>

<script>
    import  navigation from '../components/Navigation';
    import  footer1 from '../components/Footer1';
    import  newsList from '../components/NewsList';

    export default {
        name: 'index',
        components: {
            footer1,
            navigation,
            newsList
        },
        data () {
            return {
                aboutSettings: {
                    consultName:'分支机构',
                    consultId: 99999,
                    publishState: 0,
                    publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    'displayPositionIds': [1, 3],
                    'notProjectIds': [8, 9],
                    'orderWeight': true,
                    orderPublishTime: true,
                    pageNum: 1,
                    pageSize: 10
                },
            }
        },

        mounted () {

        },
        methods: {

        }
    }
</script>